// extracted by mini-css-extract-plugin
export default {"aboutInfo":"About_aboutInfo__Zw-Zm","socials":"About_socials__St9Fp"};